const scores = {
  'A+': 4+1/3,
  'A': 4,
  'A-': 4-1/3,
  'B+': 3+1/3,
  'B': 3,
  'B-': 3-1/3,
  'C+': 2+1/3,
  'C': 2,
  'C-': 2-1/3,
  'D+': 1+1/3,
  'D': 1,
  'D-': 1-1/3,
  'F+': 1/3,
  'F': 0,
  '': 0
}

const weights = {
  'Regular (4.0)': 4,
  // 'Honors (4.25)': 4.25,
  'Honors (4.5)': 4.5,
  'AP/College (5.0)': 5
}

module.exports = {
  scores,
  weights
}
